var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['flex', 'items-center', 'text-12-16', 'overflow-hidden']},[_c(_vm.isRegistered ? 'a' : 'span',{tag:"component",staticClass:"flex items-center",attrs:{"href":_vm.authorProfileUrl,"target":"_blank","data-bridged-link":"profile"}},[_c('avatar-image',{attrs:{"user":_vm.isRegistered ? _vm.author : null,"width":16,"height":16}}),_c('span',{class:[
        'text-12-16',
        'ml-2',
        {
          'text-light-text-100': _vm.colorScheme === 'dark',
          'text-dark-text-100': _vm.colorScheme === 'light',
        },
        'font-semibold' ]},[_vm._v(_vm._s(_vm.authorName))])],1),_vm._v(" "),(_vm.updatedAt)?_c('relative-time',_vm._b({class:[
      'ml-1',
      'font-normal',
      'text-12-16',
      {
        'text-light-text-300': _vm.colorScheme === 'dark',
        'text-dark-text-300': _vm.colorScheme === 'light',
      } ],attrs:{"datetime":_vm.updatedAt,"data-autorefresh":""}},'relative-time',{ text: _vm.createdAtDateString },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }